module.exports = __webpack_public_path__ + "static/img/04995473.8c4e39d8.png";